module.exports = __webpack_public_path__ + "img/4.a971f540.svg";